import { MotifAccordion, MotifAccordionContent, MotifAccordionTrigger, MotifErrorMessage } from "@ey-xd/motif-react";
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from "react";
import Button from "@/components/Form/Button/Button";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import "./DebtorInfomation.scss";
import FormModal from "@/pages/CaseDetail/CaseSetup/FormModal/FormModal";
import { DebtorData } from "./type";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/app/store";
import { resetCaseSetup, setDebtorInformation, updateFormSubmitIndex, updateStage } from "../caseSetupSlice";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import { CANCEL_BUTTON_VARIANT, CREATE_BUTTON_VARIANT, EDIT_BUTTON_VARIANT, NEXT_BUTTON_VARIANT, REMOVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";


export default function DebtorInfomation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const MODAL_TYPE = {
    CANCEL: 'CANCEL',
    REMOVE_DEBTOR: 'REMOVE_DEBTOR',
  };

  const [isVisible, setIsVisible] = useState(false);
  const [confirmationModalVisible, setConfirmationModalVisible] = useState(false);
  const [currentModalType, setCurrentModalType] = useState(null);
  const [showError, setShowError] = useState(false);

  const [removeItemIndex, setRemoveItemIndex] = useState(-1);
  const CaseSetupData = useSelector(
    (state: RootState) => state.caseSetup
  );
  const formSubmitIndex = CaseSetupData.formSubmitIndex;
  const dispatch = useDispatch();
  const [debtorData, setDebtorData] = useState<DebtorData[]>(CaseSetupData?.debtorData || []);
  const [formData, setFormData] = useState<DebtorData | null>(null);
  const [formDataIndex, setFormDataIndex] = useState(-1);

  const setPostData = (data: DebtorData, create: boolean) => {
    if (create) {
      setDebtorData([...debtorData, data]);
      setFormData(null);
    } else {
      const debtorDataCopy = [...debtorData];
      debtorDataCopy[formDataIndex] = data;
      setDebtorData(debtorDataCopy);
      setFormData(null);
      setFormDataIndex(-1);
    }
  }
  const editBtnHandler = (index: number) => {
    setIsVisible(true);
    setFormData(debtorData[index]);
    setFormDataIndex(index);
  }

  // Handler functions for different modal types
  const handleCancel = () => {
    dispatch(resetCaseSetup());
    navigate('/');
  };

  const handleRemoveDebtor = () => {
    const data = [...debtorData];
    data.splice(removeItemIndex, 1);
    setDebtorData(data);
    setRemoveItemIndex(-1);
  };
  useEffect(() => {
    dispatch(setDiscardEditMode({ editMode: true }));
    return () => {
      dispatch(setDiscardEditMode({ editMode: false }));
      dispatch(setDebtorInformation([...debtorData]));
    };
  }, [dispatch ,debtorData]);

  // Unified function to open the modal with the correct type
  const openConfirmationModal = (type: any) => {
    setCurrentModalType(type);
    setConfirmationModalVisible(true);
  };

  // Unified function to handle modal confirmation based on the type
  const handleModalConfirm = () => {
    if (currentModalType === MODAL_TYPE.CANCEL) {
      handleCancel();
    } else if (currentModalType === MODAL_TYPE.REMOVE_DEBTOR) {
      handleRemoveDebtor();
    }
    setConfirmationModalVisible(false);
  };

  // Unified function to handle modal cancellation
  const handleModalCancel = () => {
    setConfirmationModalVisible(false);
    dispatch(setDiscardEditMode({ editMode: true }));

  };

  const addBtnHandler = () => {
    setIsVisible(true);
    setFormData(null);
  }

  const moveToNext = () => {
    if (debtorData.length === 0) {  
      setShowError(true);
      return;
    }
    dispatch(setDebtorInformation(debtorData));
    dispatch(updateStage(2));
    formSubmitIndex !== 3 && dispatch(updateFormSubmitIndex(1));
  }

  const renderDebtorData = debtorData.map((debtor, index) => {
    return (
      <div className="motif-row list-item-row" key={index}>
        <div className="motif-col-lg-3 list-item">
          <div className="item-content">
            <p className="item-heading">{debtor.legalDebtorName}</p>
          </div>
        </div>
        <div className="motif-col-lg-6 list-item">
          <div className="item-content">
            <p className="item-heading">{debtor.debtorDescription}</p>
          </div>
        </div>
        <div className="motif-col-lg-2 btn-container">
          <Button className="editBtn" variant={EDIT_BUTTON_VARIANT} label={t("global.globalActions.edit")} onClickHandler={() => editBtnHandler(index)} />
          <Button  variant={REMOVE_BUTTON_VARIANT} label={t("global.globalActions.remove")} onClickHandler={() => { setRemoveItemIndex(index); openConfirmationModal(MODAL_TYPE.REMOVE_DEBTOR) }} />
        </div>
      </div>
    );
  })
  return (
    <>
      <div className="motif-col-lg-12  main-container debtor-info-container">
        <div className="motif-row t-b-padding-21">
          <div className="motif-col-xs-4">
            <p className='form-title'>{t("pages.caseSetup.debtorInformation.title")}</p>
            <p className='form-description'>{t("pages.caseSetup.debtorInformation.description")}</p>
          </div>
        </div>
        <div className="motif-row t-b-padding-21">
          <div className="motif-col-xs-4">
            <div
              style={{
                alignItems: 'flex-start',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '15px'
              }}
            >

              <MotifAccordion
                onClose={() => { }}
                onOpen={() => { }}
                style={{
                  flex: '1'
                }}
                open={true}
                useChevronIcon={true}
                alignIconRight={true}
              >
                <MotifAccordionTrigger>
                  {t("pages.caseSetup.debtorInformation.formLabels.addDebtors")}
                </MotifAccordionTrigger>
                <MotifAccordionContent>
                  <div className="motif-container pad-l-40 pad-r-20">
                    <div className="motif-row heading">
                      <div className="motif-col-lg-3 ">
                        {t("pages.caseSetup.debtorInformation.formLabels.debtorName")}
                      </div>
                      <div className="motif-col-lg-6 ">
                        {t("pages.caseSetup.debtorInformation.formLabels.description")}
                      </div>
                      <div className="motif-col-lg-2">
                      </div>
                    </div>
                    {renderDebtorData}
                    <Button variant={CREATE_BUTTON_VARIANT} label={t("pages.caseSetup.debtorInformation.formLabels.addDebtor")} className="addBtn" onClickHandler={addBtnHandler} />
                  </div>
                </MotifAccordionContent>
              </MotifAccordion>
            </div>
          </div>
        </div>
      </div>
      <div className="error-container">
        <MotifErrorMessage>
          {showError && t("pages.caseSetup.debtorInformation.requiredFields")}
        </MotifErrorMessage>
      </div>
      <div className="button-container sticky-footer">
        <Button label={t("global.globalActions.next")} variant={NEXT_BUTTON_VARIANT} type="button" onClickHandler={moveToNext} />
        <Button type="button" label={t("global.globalActions.cancel")} variant={CANCEL_BUTTON_VARIANT} className="cancelBtn" onClickHandler={() => {openConfirmationModal(MODAL_TYPE.CANCEL);      dispatch(setDiscardEditMode({ editMode: false }));
}} />
      </div>
      <ConfirmationModal
        isVisible={confirmationModalVisible}
        setIsVisible={setConfirmationModalVisible}
        cancelBtnApproveHandler={handleModalConfirm}
        cancelBtnRejectHandler={handleModalCancel}
        message={t("pages.caseSetup.debtorInformation.deleteConfirmationDescription", { debtorName:debtorData?.[removeItemIndex]?.legalDebtorName})}
        heading={t("pages.caseSetup.debtorInformation.deleteConfirmationHeader")}
      />
      <FormModal isVisible={isVisible} setIsVisible={setIsVisible} setPostData={setPostData} create={formData === null ? true : false} formData={formData} setFormData={setFormData} setShowError={setShowError}/>
    </>
  );
}